/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Comment { 
    id?: string;
    content?: string;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    code?: string;
    reply_for?: string;
    modified_by?: string;
    number_of_like?: number;
    inversereply_forNavigation?: Array<Comment>;
}